import { lazy } from 'react';
import { DeferAsyncComponentLoading } from 'unified-navigation-ui/components/DeferAsyncComponentLoading';
import { jsx as _jsx } from "react/jsx-runtime";
const NOTIFICATIONS_COMPONENT_LOAD_TIMEOUT = 0;
const AsyncThemeSwitcher = /*#__PURE__*/lazy(() => import('./components/ThemeSwitcherButton').then(({
  ThemeSwitcherButton
}) => ({
  default: ThemeSwitcherButton
})));
export const ThemeSwitcherButton = () => /*#__PURE__*/_jsx(DeferAsyncComponentLoading, {
  fallback: null,
  loadTimeout: NOTIFICATIONS_COMPONENT_LOAD_TIMEOUT,
  children: /*#__PURE__*/_jsx(AsyncThemeSwitcher, {})
});